import {Component, computed, inject, OnInit, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {ToggleSwitch} from 'primeng/toggleswitch';
import {Message} from 'primeng/message';
import {finalize} from 'rxjs';
import {
  NewsletterSubscriptionControllerService,
  NewsletterSubscriptionResponse,
  NewsletterSubscriptionStatus,
} from '@frontend/shared-api';

@Component({
  selector: 'app-newsletter-subscription',
  imports: [FormsModule, TranslocoDirective, ToggleSwitch, Message],
  templateUrl: './newsletter-subscription.component.html',
})
export class NewsletterSubscriptionComponent implements OnInit {
  private readonly newsletterSubscriptionService = inject(NewsletterSubscriptionControllerService);

  protected readonly status = signal<NewsletterSubscriptionStatus | undefined>(undefined);
  protected readonly subscribed = signal(false);
  protected readonly loading = signal(true);
  protected readonly saving = signal(false);
  protected readonly bounced = computed(
    () => this.status() === NewsletterSubscriptionStatus.BOUNCED,
  );

  ngOnInit(): void {
    this.newsletterSubscriptionService
      .getNewsletterSubscription()
      .pipe(finalize(() => this.loading.set(false)))
      .subscribe({
        next: (response) => this.applySubscription(response),
      });
  }

  onSubscribedChange(subscribed: boolean): void {
    this.subscribed.set(subscribed);
    this.saving.set(true);
    this.newsletterSubscriptionService
      .upsertNewsletterSubscription({newsletterSubscriptionRequest: {subscribed}})
      .pipe(finalize(() => this.saving.set(false)))
      .subscribe({
        next: (response) => this.applySubscription(response),
        error: () => this.subscribed.set(!subscribed),
      });
  }

  private applySubscription(response: NewsletterSubscriptionResponse): void {
    this.status.set(response.status);
    this.subscribed.set(response.status === NewsletterSubscriptionStatus.SUBSCRIBED);
  }
}
